const scoreHoverText = (type, score) => {
  let description = ''

  if (type === 'hs') {
    if (score >= 93 && score <= 100) {
      description =
        "Areas with an 'Excellent' rating may have abundant ground and surface water, with potentially no restrictions planned, or such minimal restrictions that farmers can easily meet current crop demands."
    } else if (score >= 79 && score <= 92) {
      description =
        "Areas receiving a 'Good' rating may have a reliable supply of ground and/or surface water, with minor restrictions that do not significantly impede agricultural productivity or crop water requirements."
    } else if (score >= 68 && score <= 78) {
      description =
        "An 'Average' rating is given to areas where ground and/or surface water supplies could be adequate, but some restrictions may be necessary, potentially affecting certain high-water-demand crops."
    } else if (score >= 48 && score <= 67) {
      description =
        "‘Marginal' areas may struggle with their ground and/or surface water resources, facing restrictions that can make it difficult for farmers to achieve optimal crop yields without careful water management."
    } else if (score >= 0 && score <= 47) {
      description =
        "Areas with a 'Poor' rating could face a critical shortage of ground and surface water, resulting in severe restrictions that severely limit farming operations and crop production."
    } else {
      description =
        "Areas 'Not yet rated' have not been evaluated, and thus there is no information on whether their ground and surface water supplies can sustain current and planned agricultural uses."
    }
  } else if (type === 'ss') {
    if (score >= 93 && score <= 100) {
      description =
        "Areas with an 'Excellent' Soil Score exhibit optimal chemical/physical/hydrologic characteristics that support a wide range of field crops without any significant management issues."
    } else if (score >= 79 && score <= 92) {
      description =
        "Areas receiving a 'Good' Soil Score exhibit soil conditions that generally meet crop needs with minor adjustments needed, supported by favorable conditions, allowing for stable agricultural productivity."
    } else if (score >= 68 && score <= 78) {
      description =
        "An 'Average' Soil Score is assigned to areas where soils adequately meet crop requirements but may exhibit some challenges such as less than ideal water percolation or retention, requiring moderate soil and water management strategies."
    } else if (score >= 48 && score <= 67) {
      description =
        "Areas rated as 'Marginal' face challenges with more pronounced issues like limited deep percolation or higher salinity, impacting water quality and distribution, thus necessitating careful management to optimize crop yield and health."
    } else if (score >= 0 && score <= 47) {
      description =
        "Areas with a 'Poor' Soil Score are significantly hindered by inadequate chemical/physical/hydrologic characteristics, which indicate potentially serious problems, severely limiting agricultural capabilities and crop diversity."
    } else {
      description =
        "Areas marked as 'Not yet rated' have not been assessed for their chemical/physical/hydrologic characteristics, leaving uncertainties about their suitability for agriculture based on soil and water management criteria."
    }
  }

  return description
}

export default scoreHoverText
